import { Button, Calendar, DropdownMenu, IconButton } from '@nexelem/components';
import { ChevronLeftRounded, ChevronRightRounded } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { useConfig } from '@nexelem/config';
import { useDateFormatter } from '@nexelem/utils';
import { set } from 'date-fns';
import { useCustomTranslation } from '../../../../../hooks';

export type DateRange = {
  from: Date;
  to: Date;
};

type ShiftSelectorProps = {
  onChange: (dateRange: DateRange) => void;
};

export const ShiftSelector = ({ onChange }: ShiftSelectorProps) => {
  const { tWrapper } = useCustomTranslation('products.productionPlan');
  const { modules } = useConfig();
  const [date, setDate] = useState(new Date());
  const [shiftNumber, setShiftNumber] = useState(0);
  const formatDate = useDateFormatter({ displayWithHours: false });

  const shifts = modules.production.workerModeViewShifts;
  const shift = shifts[shiftNumber];

  useEffect(() => {
    if (shift) {
      const fromTime = shift.from.split(':').map(Number);
      const toTime = shift.to.split(':').map(Number);
      const nextDay = shift.endNextDay ? 24 : 0;

      if (toTime[0]) {
        const from = set(date, { hours: fromTime[0], minutes: fromTime[1] });
        const to = set(date, { hours: toTime[0] + nextDay, minutes: toTime[1] });

        onChange({ from, to });
      }
    }
  }, [onChange, date, shift]);

  // handle day change?
  const nextShift = () => {
    setShiftNumber((shiftNumber + 1) % shifts.length);
  };

  const previousShift = () => {
    setShiftNumber((shiftNumber - 1 + 3) % shifts.length);
  };

  return (
    <div className="flex items-center">
      <DropdownMenu.Root>
        <DropdownMenu.Trigger>
          <Button variant="outlined">{formatDate(date)}</Button>
        </DropdownMenu.Trigger>
        <DropdownMenu.CalendarContainer>
          <Calendar required captionLayout="dropdown" mode="single" selected={date} onSelect={setDate} />
        </DropdownMenu.CalendarContainer>
      </DropdownMenu.Root>

      <div className="flex min-w-[255px] flex-1">
        <IconButton Icon={ChevronLeftRounded} size="small" onClick={previousShift} />
        {shift && (
          <div className="flex items-center justify-center text-nowrap">
            <span className="text-s18-sb">{tWrapper(shift.nameKey)}</span>
            <span className="text-s16 text-text-secondary">
              , {shift.from} - {shift.to}
            </span>
          </div>
        )}
        <IconButton className="ml-auto" Icon={ChevronRightRounded} size="small" onClick={nextShift} />
      </div>
    </div>
  );
};
